"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AgeIndicator = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var AgeIndicatorProps = _flowRuntime["default"].type("AgeIndicatorProps", _flowRuntime["default"].object(_flowRuntime["default"].property("day", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("month", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("year", _flowRuntime["default"].string(), true)));

var AgeIndicator = function AgeIndicator(_arg) {
  var day = _arg.day,
      month = _arg.month,
      year = _arg.year;
  var date = day && month && year && (0, _moment["default"])("".concat(year, "-").concat(month, "-").concat(day), 'YYYY-MM-DD');
  var validDate = date && date.isValid();
  var ageInYears = date && validDate ? Math.abs(date.diff((0, _moment["default"])(), 'years')).toString() : undefined;
  return ageInYears ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "col span_3_of_12 age-indicator"
  }, "You are ", /*#__PURE__*/_react["default"].createElement("strong", null, ageInYears), " years old") : null;
};

exports.AgeIndicator = AgeIndicator;
AgeIndicator.defaultProps = {
  day: '',
  month: '',
  year: ''
};